export default {
	styleOverrides: {
		asterisk: ({ theme }) => ({
			color: theme.palette.error.main,
		}),
	},
};
